import { useEffect, useRef, useState } from "react";

export default function RatingBar({ label, value }) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const obs = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setVisible(true);
                obs.disconnect();
            }
        }, { threshold: 0.4 });
        obs.observe(el);
        return () => obs.disconnect();
    }, []);

    const displayValue = visible ? value : 0;

    return (
        <div ref={ref} className="py-4" data-testid={`rating-${label.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="flex items-baseline justify-between mb-2">
                <span className="text-sm text-ink">{label}</span>
                <span className="font-serif text-lg text-forest kbd-num">{value}<span className="text-mist text-sm">/100</span></span>
            </div>
            <div className="h-[2px] w-full bg-bone overflow-hidden">
                <div
                    className="h-full bg-gold transition-[width] duration-[1400ms] ease-editorial"
                    style={{ width: `${displayValue}%` }}
                />
            </div>
        </div>
    );
}
